export type UploadMode = 'post' | 'shoot';
export type UploadAssetType = 'Still' | 'Video';

export const POST_STILL_EXTENSIONS = ['.psd', '.png'];
export const POST_VIDEO_EXTENSIONS = ['.mov', '.mp4'];
export const SHOOT_STILL_EXTENSIONS = ['.cr3', '.jpg', '.jpeg', '.png'];
export const SHOOT_VIDEO_EXTENSIONS = ['.mov', '.mp4'];

export function getAllowedExtensions(mode: UploadMode, assetType?: UploadAssetType): string[] {
  if (mode === 'shoot') {
    if (assetType === 'Video') return SHOOT_VIDEO_EXTENSIONS;
    if (assetType === 'Still') return SHOOT_STILL_EXTENSIONS;
    return [...SHOOT_STILL_EXTENSIONS, ...SHOOT_VIDEO_EXTENSIONS];
  }
  if (assetType === 'Video') return POST_VIDEO_EXTENSIONS;
  if (assetType === 'Still') return POST_STILL_EXTENSIONS;
  return [...POST_STILL_EXTENSIONS, ...POST_VIDEO_EXTENSIONS];
}

export function formatAllowedHint(extensions: string[]): string {
  return `Allowed: ${extensions.join(', ')}`;
}

export function getFileExtension(fileName: string): string {
  const lastDot = fileName.lastIndexOf('.');
  return lastDot < 0 ? '' : fileName.substring(lastDot).toLowerCase();
}

export function validateFileExtension(file: File, extensions: string[]): { valid: true } | { valid: false; error: string } {
  const ext = getFileExtension(file.name);
  return extensions.includes(ext)
    ? { valid: true }
    : { valid: false, error: `Invalid file type "${ext}". ${formatAllowedHint(extensions)}` };
}
